<script>
import viewport from 'linna/services/viewport'

import CrtFrame from '@/components/CrtFrame.vue'
import SlowChannelChange from '@/components/transitions/SlowChannelChange.vue'

import notifications from '@/services/notifications'

export default {
  name: 'App',

  components: {
    CrtFrame,
    SlowChannelChange
  },

  data () {
    return {
      debugIsVisible: false
    }
  },

  computed: {

    obtrusiveScrollbars () {
      return viewport.hasObtrusiveScrollbars
    },

    routeKey () {
      return this.$route.matched[0] ? this.$route.matched[0].name : ''
    }

  },

  watch: {

    routeKey: {
      immediate: true,

      // Channel change text
      handler (routeKey) {
        notifications.overlayTitle = routeKey
      }
    }

  },

  methods: {

    toggleDebug () {
      this.debugIsVisible = !this.debugIsVisible
    }

  }

}
</script>

<template>
  <div
    :class="{
      'c-app-obtrusive-scrollbars': obtrusiveScrollbars
    }"
    class="c-app"
  >
    <crt-frame class="c-app-screen">
      <slow-channel-change>
        <router-view :key="routeKey" />
      </slow-channel-change>
    </crt-frame>
  </div>
</template>

<style lang="scss">

// Global styles
@import './styles/global';

.c-app {
  @include relative;
  width: 100%;
  height: 100%;
  user-select: none;
}

.c-app-obtrusive-scrollbars {
  @include custom-scrollbars;
  @include custom-scrollbar-transitions;
}

.c-app-screen {
  @include fill;
}

</style>
